import React from "react";

interface CheckoutTextButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
  className?: string;
}

const CheckoutTextButton: React.FC<CheckoutTextButtonProps> = ({
  children,
  disabled = false,
  onClick,
  type = "button",
  className = "",
}) => (
  <button
    type={type}
    className={`split-ui-link-button${className ? ` ${className}` : ""}`}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export default CheckoutTextButton;
